module.exports = __webpack_public_path__ + "static/media/most-goals.66c091cd.png";